export default __webpack_public_path__ + "static/media/about5.e871beda.png";